
// Handler for Buy Two Get One Free promo
// Require buyer to select 3 items
// Offer to add more books if multiples of 3 aren't selected 


const swal = require('sweetalert2');

$(document).ready(() => {
    //this portion of the script requires the user to select at least x number of checkboxes 
    $('#Order').submit((e) => {
        //get all checkboxes with a class of 'checkboxclass'
        var checked = $('.checkboxclass').filter(':checked');
        var num_checked = checked.length;
        var format = e.target.format.value;
        for (var i = 0; i < checked.length; i++) {
            var checkbox = checked[i];
            const parts = checkbox.value.split("^");
            if (format === "physical") {
                parts[1] = parts[1].replace(/^OP/, '');
            } else {
                parts[1] = parts[1].replace(/^(OP)?/, 'OP');
            }
            checked[i].value = parts.join("^");
        }

        if (num_checked < 3) {
            swal('Must Choose 3', `You have selected ${num_checked} book${num_checked === 1 ? '' : 's'}. Please select 3 Quiz-Quiz-Trade books.`, 'error');
            return false;
        }
        
        
        // If the buyer selects a quantity that's not a multiple of three, offer to add more to recieve another free item.
        
          if (num_checked % 3) {
            const num = 3 - (num_checked % 3);
 
            swal({
                title: 'Add More?',
                text: `Add ${num} more book${num === 1 ? '' : 's'} to receive another free one!`,
                confirmButtonText: 'Proceed to Checkout',
                cancelButtonText: 'Continue Shopping',
                showCancelButton: true
            }).then(({ value, dismiss }) => {
                if (value || dismiss == 'overlay') {
                    $('#Order')[0].submit();
                }
            }).catch();
 
            return false;
        } 
        
    });
});